<template>
  <div class="w-full grid lg:grid-cols-2 xl:grid-cols-3 gap-16">
    <ComplexCard v-for="index in numberOfCards" :key="index" :loading="true" variant="base" />
  </div>
</template>

<script lang="ts">
import ComplexCard from '@/components/complex_card/ComplexCard.vue';

export default {
  name: 'SearchSkeleton',
  components: { ComplexCard },
  computed: {
    numberOfCards(): number {
      return 12;
    },
  },
};
</script>
